<template>
  <section class="p-6 bg-gray-50 ">
    <h1 class="text-3xl font-extrabold mb-6 text-gray-700 border-b pb-2">庫存管理 Dashboard</h1>

    <!-- Loading / Error -->
    <div v-if="loading" class="text-gray-700 font-medium">Loading...</div>
    <div v-else-if="error" class="text-red-700 font-medium">{{ error }}</div>

    <!-- Inventory Cards -->
    <div v-else class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
      <div 
        v-for="item in items" 
        :key="item.id" 
        class="bg-white p-5 rounded-xl shadow hover:shadow-lg transition-shadow duration-100 border-l-4"
        :class="item.stock > 5 ? 'border-green-700' : 'border-red-700'"
      >
        <h2 class="text-lg font-semibold text-gray-700 mb-2">{{ item.name }}</h2>
        <p class="text-gray-700 font-mono">庫存: <span class="font-bold">{{ item.stock }}</span></p>
        <p class="mt-2 text-sm" :class="item.stock > 5 ? 'text-green-700' : 'text-red-700'">
          {{ item.stock > 5 ? '庫存充足' : '庫存不足' }}
        </p>
      </div>
    </div>

    <!-- Refresh Button -->
    <div class="mt-6">
      <button 
        @click="load" 
        class="px-5 py-2 bg-blue-700 text-white font-semibold rounded-lg shadow hover:bg-blue-700 transition-colors duration-150"
      >
        重新整理
      </button>
      <button class="bg-red-700 text-white">測試紅色</button>

    </div>
  </section>
</template>
<script setup lang="ts">
import { useInventory, type InventoryApi } from '../useInventory'

/**
 * Props 接收外部傳入的 API
 */
const props = defineProps<{
  api: InventoryApi
}>()

// ⚡ 使用 props.api
const { items, loading, error, load } = useInventory(props.api)
</script>
